import AlgoliaInstantSearch from './AlgoliaInstantSearch';
export default AlgoliaInstantSearch;